import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#177a97',
        secondary: '#eecc57',
        // accent: '#e8b919'
        accent: '#ff6f00',
        // error: '#b71c1c',
        text: {
          primary: '#186fa5'
        }
      }
    }
  }
})
